export default {
  accountingPeriods: state => state.accountingPeriods,
  isCallingAccounting: state => state.isCallingAccounting
}
